#import "./inbox-related-lead-fragment.graphql"

fragment InboxSidebarThreadFragment on Thread {
    id
    effectiveStatus
    messageCount
    threadSummary
    displayMessage {
        id
        content
    }
    externalChannel {
        id
        phone {
            id
            numberFormattedWithCountryCode
        }
        email {
            address
        }
    }
    bestEntity {
        id
        name
        avatarUrl
        htmlUrlPath
        ... on Contact {
            initials
        }
        ... on Account {
            initials
        }
    }
    stubEntity {
        id
        name
        avatarUrl
        htmlUrlPath
        initials
    }
    relatedLeads {
        ...InboxRelatedLeadFragment
    }
    threadType
}
